import { css } from '@emotion/css';
import {
    getVisibleTabulatorFilters,
    shouldShowTabulatorFiltersDrawer,
    TabulatorFilterConfig,
} from '@shadcn-features/core/ShadcnTabulator/components/filters.config';
import { ShadcnTabulatorActiveFilters } from '@shadcn-features/core/ShadcnTabulator/components/ShadcnTabulatorActiveFilters';
import { ShadcnTabulatorFiltersDrawer } from '@shadcn-features/core/ShadcnTabulator/components/ShadcnTabulatorFiltersDrawer';
import { ShadcnTabulatorPinnedFilters } from '@shadcn-features/core/ShadcnTabulator/components/ShadcnTabulatorPinnedFilters';
import { useWindowDimensions } from '@shadcn-features/core/util/useWindowDimensions';
import { useState } from 'react';

type Props = {
    filters: TabulatorFilterConfig[];
};

export function TableFieldFilterRow({ filters }: Props) {
    const { isMobile } = useWindowDimensions();
    const [pinnedFilters, setPinnedFilters] = useState<string[]>(() => {
        const nonMainFilters = filters.filter((filter) => !filter.mainFilter);
        const manualPinned = nonMainFilters
            .filter((filter) => filter.pinned)
            .map((filter) => filter.key);

        if (manualPinned.length > 0) {
            return manualPinned;
        }

        return nonMainFilters.slice(0, 3).map((filter) => filter.key);
    });

    const togglePin = (key: string) => {
        const filter = filters.find((item) => item.key === key);
        if (filter?.mainFilter) {
            return;
        }

        setPinnedFilters((prev) => {
            if (prev.includes(key)) {
                return prev.filter((item) => item !== key);
            }

            if (prev.length >= 3) {
                return prev;
            }

            return [...prev, key];
        });
    };

    const visibleFilters = getVisibleTabulatorFilters(filters).map((filter) =>
        isMobile
            ? filter
            : {
                  ...filter,
                  type:
                      !filter.mainFilter && filter.type === 'input'
                          ? ('popoverInput' as const)
                          : filter.type,
                  className: filter.mainFilter
                      ? 'table-field__search'
                      : filter.className,
              },
    );
    const showFiltersDrawer = shouldShowTabulatorFiltersDrawer(visibleFilters);

    if (!visibleFilters.length) {
        return null;
    }

    return (
        <div
            className={`table-field__filters ${css`
                display: flex;
                gap: 2px;
                flex-direction: column;
                width: 100%;
            `}`}
        >
            <div
                className={css`
                    display: flex;
                    align-items: center;
                    width: 100%;
                `}
            >
                <ShadcnTabulatorPinnedFilters
                    filters={visibleFilters}
                    pinnedKeys={pinnedFilters}
                    filtersDrawer={
                        showFiltersDrawer ? (
                            <ShadcnTabulatorFiltersDrawer
                                filters={visibleFilters}
                                pinnedKeys={pinnedFilters}
                                onTogglePin={togglePin}
                            />
                        ) : undefined
                    }
                />
            </div>
            <div
                className={css`
                    width: 100%;
                `}
            >
                <ShadcnTabulatorActiveFilters filters={visibleFilters} />
            </div>
        </div>
    );
}
